import React, {Component} from 'react';
import PropTypes from 'prop-types';
const { URL } = window;
export default class FacebookIcon extends Component{
    constructor(props){
        super(props);
    }

    render(){
        const { title } = document;
        let docUrl = new URL(document.location);
        docUrl.searchParams.set("src","stfb");

        let targetUrl = new URL("https://www.facebook.com/share.php");
        targetUrl.searchParams.set("u",docUrl.href);
        targetUrl.searchParams.set("t",title);

        const aProps = {
            href: targetUrl.href,
            target: "_blank",
            onClick: this.props.onClick
        }
        return(
            <div className="facebook-icon icon-container">
                <a {...aProps}>
                    <span className="icon-title">Facebook</span>
                    <svg width="5" height="12" viewBox="0 0 5 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g transform="translate(-283.000000, -964.000000)" fill="#3D5D97">
                                <g transform="translate(269.000000, 954.000000)">
                                    <path d="M14.9188361,22 L16.7565084,22 L16.7565084,15.568147 L18.7715161,15.568147 L18.9828484,13.7304747 L16.7565084,13.7304747 L16.7565084,12.5525268 C16.7565084,12.1004594 17.4401225,11.8928025 17.6523737,11.8928025 L18.5941807,11.8928025 L18.5941807,10.0073507 L17.0808576,10 C15.0915773,10 14.9188361,11.4830015 14.9188361,12.4312404 L14.9188361,13.7304747 L14,13.7304747 L14,15.568147 L14.9188361,15.568147 L14.9188361,22"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
        )
    }
    static get propTypes() {
        return {
            onClick: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            onClick: () => {}
        }
    }
}
